import React, { useState } from "react";
import ImpactSection from "../../components/ImpartSec/ImpartSec";
import "./About.css";

const About = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const results = [
    {
      number: "150+",
      title: "Projects Delivered",
      description:
        "Websites, campaigns, SEO projects and digital marketing solutions successfully delivered.",
    },
    {
      number: "40%+",
      title: "Average Growth",
      description:
        "Focused strategies designed to improve traffic, leads, conversions and overall online performance.",
    },
    {
      number: "3X",
      title: "More Qualified Leads",
      description:
        "Conversion-focused campaigns built to attract the right audience and generate better opportunities.",
    },
    {
      number: "90%+",
      title: "Client Satisfaction",
      description:
        "Long-term relationships built through communication, transparency and consistent results.",
    },
  ];

  const reviews = [
    {
      name: "Ahmed Khan",
      company: "Business Owner",
      review:
        "The team understood our goals from the beginning and created a strategy that actually delivered results. Communication was excellent throughout the project.",
    },
    {
      name: "Sarah Williams",
      company: "Founder",
      review:
        "Very professional team. Our website looks much better and we started receiving more relevant enquiries after the improvements.",
    },
    {
      name: "Michael Thomas",
      company: "Marketing Manager",
      review:
        "Great experience from start to finish. They were transparent about the strategy, explained everything clearly and focused on measurable growth.",
    },
    {
      name: "Usman Ali",
      company: "Business Owner",
      review:
        "What I liked most was their focus on actual business results instead of just vanity metrics. Highly recommended for digital marketing.",
    },
    {
      name: "Emma Davis",
      company: "Company Director",
      review:
        "Professional, responsive and very easy to work with. The team helped us improve our online presence and generate better quality leads.",
    },
    {
      name: "Daniel Wilson",
      company: "Entrepreneur",
      review:
        "A reliable digital marketing team with a strong understanding of websites, SEO and paid advertising. Very happy with the overall work.",
    },
  ];

  const faqs = [
    {
      question: "What digital marketing services do you provide?",
      answer:
        "We provide a complete range of digital marketing services including Google Ads, Meta Ads, SEO, social media marketing, web development, content marketing and conversion rate optimization.",
    },
    {
      question: "How do you measure campaign success?",
      answer:
        "We focus on measurable business metrics such as qualified leads, conversions, cost per lead, website traffic, conversion rate and return on advertising spend.",
    },
    {
      question: "How long does it take to see results?",
      answer:
        "The timeline depends on the service and your current online presence. Paid advertising can generate data and leads quickly, while SEO and organic growth usually require consistent work over a longer period.",
    },
    {
      question: "Do you provide customized strategies?",
      answer:
        "Yes. Every business has different goals, audiences and challenges. We analyze your business and create a strategy based on your specific objectives rather than using a one-size-fits-all approach.",
    },
    {
      question: "Can you improve my existing website?",
      answer:
        "Yes. We can review your existing website and improve its design, performance, mobile experience, content, user journey and conversion elements.",
    },
    {
      question: "Do you provide monthly marketing support?",
      answer:
        "Yes. We can provide ongoing marketing support, campaign optimization, SEO improvements, content strategies and performance monitoring based on your business requirements.",
    },
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="about-page">

      {/* =====================================================
          RESULTS
      ===================================================== */}
      <section className="google-reviews-section">

        <div className="about-section-heading reviews-heading">

          <span>GOOGLE REVIEWS</span>

          <h2>
            What Our <strong>Clients Say.</strong>
          </h2>

          <p>
            Real relationships are built through transparency,
            communication and results.
          </p>

          <div className="google-rating">

            <div className="google-stars">
              ★★★★★
            </div>

            <span>5.0</span>

            <small>
              Google Reviews
            </small>

          </div>

        </div>


        <div className="reviews-grid">

          {reviews.map((review, index) => (
            <div className="review-card" key={index}>

              <div className="review-top">

                <div className="review-avatar">
                  {review.name.charAt(0)}
                </div>

                <div className="review-person">

                  <h3>
                    {review.name}
                  </h3>

                  <span>
                    {review.company}
                  </span>

                </div>

              </div>


              <div className="review-stars">
                ★★★★★
              </div>


              <p className="review-text">
                "{review.review}"
              </p>


              <div className="google-review-label">

                <span className="google-icon">
                  G
                </span>

                <span>
                  Google Review
                </span>

              </div>

            </div>
          ))}

        </div>

      </section>

      <ImpactSection/>


      {/* =====================================================
          FAQ
      ===================================================== */}
      <section className="about-faq-section">

        <div className="about-section-heading faq-heading">

          <span>FAQ</span>

          <h2>
            Questions? We've Got
            <strong> Answers.</strong>
          </h2>

          <p>
            Everything you need to know before getting started
            with our digital marketing services.
          </p>

        </div>


        <div className="faq-container">

          {faqs.map((faq, index) => (

            <div
              className={`faq-item ${
                openFaq === index ? "faq-open" : ""
              }`}
              key={index}
            >

              <button
                className="faq-question"
                onClick={() => toggleFaq(index)}
                aria-expanded={openFaq === index}
              >

                <span>
                  {faq.question}
                </span>

                <span className="faq-icon">
                  {openFaq === index ? "−" : "+"}
                </span>

              </button>


              <div className="faq-answer">

                <p>
                  {faq.answer}
                </p>

              </div>

            </div>

          ))}

        </div>

      </section>

    </div>
  );
};

export default About;